import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import logger from "redux-logger";
import { loadState, saveState } from "../utils";
import sagas from "./saga";

import accountingReducer from "./slices/accounting";
import accountsReducer from "./slices/accounts";
import addOnsReducer from "./slices/addOns";
import brandsReducer from "./slices/brands";
import bulkUploadReduer from "./slices/bulk-upload";
import businessReducer from "./slices/business";
import catalogReducer from "./slices/catalog";
import channelMenuReducer from "./slices/channel-menu";
import chargesAndDiscountsReducer from "./slices/chargesAndDiscounts";
import dashboardReducer from "./slices/dashboard";
import galleryReducer from "./slices/gallery";
import itemSchedulesReducer from "./slices/itemSchedules";
import loginReducer from "./slices/login";
import menusReducer from "./slices/menus";
import outletStatusReducer from "./slices/outlet-status";
import pnlStatementReducer from "./slices/pnl-statement";
import reportsReducer from "./slices/reports";
import requestHeadersReducer from "./slices/request-headers";
import savedReportReducer from "./slices/downloads";
import taxesReducer from "./slices/taxes";
import commonReducer from "./slices/common";
import tablesReducer from "./slices/tables";
import notificationsReducer from "./slices/notifications";

const sagaMiddleware = createSagaMiddleware();
const preloadedState = loadState();

const store: any = configureStore({
  reducer: {
    accountingReducer: accountingReducer,
    accountsReducer: accountsReducer,
    addOnsReducer: addOnsReducer,
    brandsReducer: brandsReducer,
    bulkUploadReduer: bulkUploadReduer,
    businessReducer: businessReducer,
    catalogReducer: catalogReducer,
    channelMenuReducer: channelMenuReducer,
    chargesAndDiscountsReducer: chargesAndDiscountsReducer,
    dashboardReducer: dashboardReducer,
    galleryReducer: galleryReducer,
    itemSchedulesReducer: itemSchedulesReducer,
    loginReducer: loginReducer,
    menusReducer: menusReducer,
    outletStatusReducer: outletStatusReducer,
    pnlStatementReducer: pnlStatementReducer,
    reportsReducer: reportsReducer,
    requestHeadersReducer: requestHeadersReducer,
    savedReportReducer: savedReportReducer,
    taxesReducer: taxesReducer,
    commonReducer: commonReducer,
    tablesReducer: tablesReducer,
    notificationsReducer
  },
  preloadedState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: false, serializableCheck: false })
      .concat(sagaMiddleware)
      .concat(logger),
});

store.subscribe(() => {
  saveState({
    accountingReducer: store.getState().accountingReducer,
    accountsReducer: store.getState().accountsReducer,
    addOnsReducer: store.getState().addOnsReducer,
    brandsReducer: store.getState().brandsReducer,
    bulkUploadReduer: store.getState().bulkUploadReduer,
    businessReducer: store.getState().businessReducer,
    catalogReducer: store.getState().catalogReducer,
    channelMenuReducer: store.getState().channelMenuReducer,
    chargesAndDiscountsReducer: store.getState().chargesAndDiscountsReducer,
    dashboardReducer: store.getState().dashboardReducer,
    galleryReducer: store.getState().galleryReducer,
    itemSchedulesReducer: store.getState().itemSchedulesReducer,
    loginReducer: store.getState().loginReducer,
    menusReducer: store.getState().menusReducer,
    outletStatusReducer: store.getState().outletStatusReducer,
    pnlStatementReducer: store.getState().pnlStatementReducer,
    reportsReducer: store.getState().reportsReducer,
    requestHeadersReducer: store.getState().requestHeadersReducer,
    savedReportReducer: store.getState().savedReportReducer,
    taxesReducer: store.getState().taxesReducer,
    commonReducer: store.getState().commonReducer,
    tablesReducer: store.getState().tablesReducer,
    notificationsReducer: store.getState().notificationsReducer,
  });
});

sagaMiddleware.run(sagas);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
